import { ReactElement } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { analytics } from 'libs';

interface SideNavItemProps {
  hasNotification?: boolean;
  icon: ReactElement;
  isActive?: boolean;
  isExternalRoute?: boolean;
  label?: string;
  name: string;
  shouldOpenNewWindow?: boolean;
  state?: Record<string, unknown>;
  to: string;
}

const SideNavItem = ({
  hasNotification = false,
  icon,
  isActive = false,
  isExternalRoute = false,
  label,
  name,
  shouldOpenNewWindow = false,
  state = {},
  to,
}: SideNavItemProps) => (
  <div className="side-navbar__navlink-container">
    {isExternalRoute ? (
      <a
        aria-label={label}
        className="side-navbar__navlink"
        data-testid={`side-navbar-navlink-${name}`}
        href={to}
        onClick={analytics.navigation.onDesktop(name)}
        rel={shouldOpenNewWindow ? 'noopener noreferrer' : undefined}
        target={shouldOpenNewWindow ? '_blank' : undefined}
      >
        <span className="side-navbar__navlink-icon d-inline-block w-6 leading-none text-white">
          {icon}
          {hasNotification && (
            <span
              aria-hidden="true"
              className="side-navbar__notification-dot"
              data-testid={`side-navbar-navlink-${name}-notification`}
            />
          )}
        </span>
      </a>
    ) : (
      <Link
        aria-label={label}
        className={classnames('side-navbar__navlink', {
          active: isActive,
        })}
        data-testid={`side-navbar-navlink-${name}`}
        state={state}
        to={to}
        onClick={analytics.navigation.onDesktop(name)}
      >
        <span className="side-navbar__navlink-icon d-inline-block w-6 leading-none text-white">
          {icon}
          {hasNotification && (
            <span
              aria-hidden="true"
              className="side-navbar__notification-dot"
              data-testid={`side-navbar-navlink-${name}-notification`}
            />
          )}
        </span>
      </Link>
    )}
    <div className="side-navbar__label">{label}</div>
  </div>
);

export default SideNavItem;
